<template>
  <div class="module-position">
    <NebulaButton
      :text="$t('Move to Front')"
      icon-left="bring-to-front"
      type="flat"
      size="s"
      @click="moveToFront"
    />
    <NebulaButton
      :text="$t('Move Forwards')"
      icon-left="bring-forwards"
      type="flat"
      size="s"
      @click="moveForward"
    />
    <NebulaButton
      :text="$t('Move to Back')"
      icon-left="send-to-back"
      type="flat"
      size="s"
      @click="moveToBack"
    />
    <NebulaButton
      :text="$t('Move Backwards')"
      icon-left="send-backwards"
      type="flat"
      size="s"
      @click="moveBackward"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import {
  NebulaButton,
} from '@discoveryedu/nebula-components';
import {
  createTopZPosition,
  createBottomZPosition,
  createForwardZPosition,
  createBackwardZPosition,
} from '@/lib/utils/grid';
import {
  useEditorStore,
} from '@/stores';
import * as types from '@/lib/constants/store';

export default {
  components: {
    NebulaButton,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    canvasName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'currentModalCanvasId',
      'modulesOrderedByZPosition',
      'getModulesByModalIdOrderedByZPosition',
    ]),
    modulesOrderedByZ() {
      if (this.canvasName === 'modalModules') {
        return this.getModulesByModalIdOrderedByZPosition(this.currentModalCanvasId);
      }

      return this.modulesOrderedByZPosition;
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.UPDATE_MODULES,
    ]),
    createTopZPosition,
    createBottomZPosition,
    createForwardZPosition,
    createBackwardZPosition,
    moveZPosition(moveFunction) {
      const modToUpdate = this.modulesOrderedByZ.find((mod) => mod.id === this.id);
      if (modToUpdate) {
        // Calculate the z_position to move to.
        const newZPosition = moveFunction(
          this.modulesOrderedByZ,
          modToUpdate.layout.z_position,
        );
        // If the new z_position is different, then do the update.
        if (newZPosition !== modToUpdate.layout.z_position) {
          modToUpdate.layout.z_position = newZPosition;
          this[types.UPDATE_MODULES]({ canvasName: this.canvasName, modules: [modToUpdate] });
        }
      }
    },
    moveToFront() {
      this.moveZPosition(this.createTopZPosition);
    },
    moveToBack() {
      this.moveZPosition(this.createBottomZPosition);
    },
    moveForward() {
      this.moveZPosition(this.createForwardZPosition);
    },
    moveBackward() {
      this.moveZPosition(this.createBackwardZPosition);
    },
  },
};
</script>
